import { render, staticRenderFns } from "./welinkBind.vue?vue&type=template&id=36716bb8&scoped=true"
import script from "./welinkBind.vue?vue&type=script&lang=js"
export * from "./welinkBind.vue?vue&type=script&lang=js"
import style0 from "./welinkBind.vue?vue&type=style&index=0&id=36716bb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36716bb8",
  null
  
)

export default component.exports